/**
 * Âge des patients : mêmes règles que le serveur (Patient::getAgeAffiche).
 *  - moins d'un mois : « 12 jours » ; moins de 2 ans : « 7 mois » ; ensuite « 4 ans » ;
 *  - « environ » devant quand la date de naissance est estimée ;
 *  - mineur : moins de 18 ans.
 */

export const AGE_MAJORITE = 18

function jourLocal(valeur) {
  if (!valeur) return null
  const [a, m, j] = String(valeur).slice(0, 10).split('-').map(Number)
  if (!a || !m || !j) return null
  return new Date(a, m - 1, j)
}

function aujourdhui() {
  const d = new Date()
  return new Date(d.getFullYear(), d.getMonth(), d.getDate())
}

/** Écart en années, mois et jours révolus entre deux dates (jour près). */
function ecart(debut, fin) {
  let annees = fin.getFullYear() - debut.getFullYear()
  let mois = fin.getMonth() - debut.getMonth()
  let jours = fin.getDate() - debut.getDate()
  if (jours < 0) {
    mois--
    jours += new Date(fin.getFullYear(), fin.getMonth(), 0).getDate()
  }
  if (mois < 0) {
    annees--
    mois += 12
  }
  return { annees, mois, jours }
}

export function ageAnnees(dateNaissance) {
  const n = jourLocal(dateNaissance)
  if (!n || n > aujourdhui()) return null
  return ecart(n, aujourdhui()).annees
}

export function estMineur(dateNaissance) {
  const a = ageAnnees(dateNaissance)
  return a === null ? null : a < AGE_MAJORITE
}

export function ageAffiche(dateNaissance, estimee = false) {
  const n = jourLocal(dateNaissance)
  const t = aujourdhui()
  if (!n || n > t) return null
  const { annees, mois } = ecart(n, t)
  const totalMois = annees * 12 + mois
  let texte
  if (totalMois < 1) {
    const jours = Math.round((t - n) / 86400000)
    texte = jours + (jours > 1 ? ' jours' : ' jour')
  } else if (totalMois < 24) {
    texte = totalMois + ' mois'
  } else {
    texte = annees + ' ans'
  }
  return (estimee ? 'environ ' : '') + texte
}

/** Date de naissance approximative à partir d'un âge déclaré (« 4 ans et 6 mois »). */
export function dateDepuisAge(annees, mois) {
  const a = Math.max(0, parseInt(annees, 10) || 0)
  const m = Math.max(0, parseInt(mois, 10) || 0)
  if (!a && !m) return ''
  const t = aujourdhui()
  // Mois cible, puis jour ramené au dernier jour du mois (31 octobre - 8 mois = 28/29 février)
  const total = t.getFullYear() * 12 + t.getMonth() - (a * 12 + m)
  const annee = Math.floor(total / 12)
  const moisCible = total % 12
  const jour = Math.min(t.getDate(), new Date(annee, moisCible + 1, 0).getDate())
  const z = (x) => String(x).padStart(2, '0')
  return `${annee}-${z(moisCible + 1)}-${z(jour)}`
}

export const LIENS_RESPONSABLE = [
  { valeur: 'MERE', libelle: 'Mère' },
  { valeur: 'PERE', libelle: 'Père' },
  { valeur: 'TUTEUR', libelle: 'Tuteur / tutrice' },
  { valeur: 'AUTRE', libelle: 'Autre' },
]

export const DESTINATAIRES_SMS = [
  { valeur: 'AUTO', libelle: 'Automatique : le responsable pour un mineur, sinon le patient' },
  { valeur: 'PATIENT', libelle: 'Le patient' },
  { valeur: 'RESPONSABLE', libelle: 'Le responsable légal' },
  { valeur: 'LES_DEUX', libelle: 'Le patient et le responsable' },
]
